import { render } from "./ProfilePage.vue?vue&type=template&id=2ea9c56f&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"

import "./ProfilePage.vue?vue&type=style&index=0&id=2ea9c56f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea9c56f"]])

export default __exports__